module.exports = __webpack_public_path__ + "static/media/lightbulb.2b2c1ae6.svg";